"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManyToOne = void 0;
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("../../styled-components");
const Base_1 = require("../Base");
const ManyToOne = ({ height, width, title = "Many-to-one", fill = "#84E3FF", }) => {
    const theme = (0, styled_components_1.useTheme)();
    return (react_1.default.createElement(Base_1.Base, { smooth: true, height: height, width: width, fill: fill, title: title, viewBox: "0 0 96 32" },
        react_1.default.createElement("g", null,
            react_1.default.createElement("path", { fill: theme.icon, d: "M83,24c0,1.7-1.3,3-3,3s-3-1.3-3-3c0-1.3,0.8-2.4,2-2.8V5h2v16.2C82.2,21.6,83,22.7,83,24z" }),
            react_1.default.createElement("path", { fill: theme.icon, d: "M90,24c0,1.7-1.3,3-3,3s-3-1.3-3-3c0-1.3,0.8-2.4,2-2.8V5h2v16.2C89.2,21.6,90,22.7,90,24z" }),
            react_1.default.createElement("path", { fill: theme.icon, d: "M76,24c0,1.7-1.3,3-3,3s-3-1.3-3-3c0-1.3,0.8-2.4,2-2.8V5h2v16.2C75.2,21.6,76,22.7,76,24z" }),
            react_1.default.createElement("path", { fill: theme.icon, d: "M15,14v1l3-3v3l-3,3v1l3-3v3l-3,3v1l3-3v4l-2,3l-2-3V5h4v6L15,14z" }),
            react_1.default.createElement("path", { fill: fill, d: "M59,17H44v3l-7-4l7-4v3h15V17z" }))));
};
exports.ManyToOne = ManyToOne;
//# sourceMappingURL=ManyToOne.js.map